import { PATHNAMES } from "src/constants/routes";

export const createHashPath = (
  hashName: string,
  parentPath: string = PATHNAMES.HOME
): string => `${parentPath}#${hashName}`;

export const addHash = (id: string) => `#${id}`;
